import { render, staticRenderFns } from "./ProjectMetricsInfoCard.vue?vue&type=template&id=3ef11548&scoped=true"
import script from "./ProjectMetricsInfoCard.vue?vue&type=script&lang=js"
export * from "./ProjectMetricsInfoCard.vue?vue&type=script&lang=js"
import style0 from "./ProjectMetricsInfoCard.vue?vue&type=style&index=0&id=3ef11548&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef11548",
  null
  
)

export default component.exports